<template>
  <ListLayout
    :title="`${fleetModule.driverPlural}`"
    :tableData="driverList"
    :tableHeader="tableHeaders"
    :total="totalItems"
    :context="context"
    :tableScrollable="false"
    ref="listTable"
    localStorageKey="drivers_columns"
    :isColumnShowVisibility="true"
    @getList="getDriverList"
  >
    <template #listAction>
      <SecondaryButton
        id="driversExport"
        btnClass="mr-2 rounded-lg"
        outlined
        iconClass="secondary--text mr-2"
        name="Export"
        icon="mdi-download"
        iconSize="lg"
        @click="openDownloadDialog = true"
      />
      <v-menu offset-y v-if="permissions && permissions.add">
        <template v-slot:activator="{ on: menu, attrs }">
          <v-tooltip bottom :color="isButtonDisabled ? 'error' : ''">
            <template v-slot:activator="{ on: tooltip }">
              <div v-on="{ ...tooltip }">
                <PrimaryButton
                  id="driversAdd"
                  :disabled="isButtonDisabled"
                  v-bind="attrs"
                  v-on="{ ...menu }"
                  :name="`Add ${fleetModule.driver}`"
                  icon="mdi-plus"
                  iconSize="lg"
                >
                </PrimaryButton>
              </div>
            </template>
            <span>{{ buttonTooltip }}</span>
          </v-tooltip>
        </template>
        <v-list dense flat>
          <v-list-item id="add-driver" @click="$router.push({ name: 'add-driver' })">
            <v-list-item-title>Add {{ fleetModule.driver }}</v-list-item-title>
          </v-list-item>
          <v-list-item id="import-driver" @click="showBulkUploadDialog = true">
            <v-list-item-title
              >Import {{ fleetModule.driver }}</v-list-item-title
            >
          </v-list-item>
        </v-list>
      </v-menu>
    </template>
    <template #rightFilterSlot>
      <div class="d-flex align-center justify-end w-100">
        <RefreshListButton
          id="driversRefreshList"
          :isIcon="false"
          @click="$refs.listTable.searchTriggered()"
        />
        <DriverFilter
          :filter="driverFilters"
          :isChips="isChipsVisible"
          @apply="$refs.listTable.itemsPerPageChanged(itemsPerPage)"
          @reset="resetFilters"
        />
      </div>
    </template>
    <template #dialogs>
      <ViewDriver v-model="openDriverDetail" :id="selectedId" />
      <DownloadSheet
        v-model="openDownloadDialog"
        :title="`Export ${fleetModule.driver} Sheet`"
        module="driver"
        method="downloadDriverSheet"
      />
      <BulkUpload
        uploadTo="driver"
        v-model="showBulkUploadDialog"
        :hasBulkActions="true"
        @refreshList="
          checkSubscriptionLimit();
          $refs.listTable.itemsPerPageChanged(itemsPerPage);
        "
      />
      <DriverStatusChanged
        v-model="showDriverStatusChangedDialog"
        :currentDriverStatus="selectedDriverStatus"
        :driverID="selectedDriverID"
        @refreshList="getDriverList({ limit: 10, offset: 0 })"
      />
      <DocumentListForm
        moduleType="Driver"
        v-model="documentUploadFormDialog"
        :parentObj="driverDetail"
      />
    </template>
  </ListLayout>
</template>

<script>
/* eslint-disable vue/no-unused-components */
import { bus } from "@/main.js";
import DriverButton from "@/components/Button/DriverButton.vue";
import ListLayout from "@/components/LayoutComponents/ListLayout.vue";
import ViewDriver from "@/pages/client/driver/ViewDriver.vue";
import DownloadSheet from "@/components/GeneralComponents/DownloadSheet.vue";
import BulkUpload from "@/components/BaseComponents/BulkUpload.vue";
import DriverFilter from "@/components/ModuleBasedComponents/Driver/DriverFilter.vue";
import DriverStatusChanged from "@/components/ModuleBasedComponents/Driver/DriverStatusChanged.vue";
import DocumentListForm from "@/components/GeneralComponents/DocumentListForm.vue";
import RefreshListButton from "@/components/BaseComponents/RefreshListButton.vue";
import { mapState } from "vuex";
import { filterModules } from "@/utils/fieldConstants";
import { fleetModule } from "@/utils/moduleMapping";

export default {
  components: {
    DriverButton,
    ListLayout,
    ViewDriver,
    DownloadSheet,
    BulkUpload,
    DriverFilter,
    DriverStatusChanged,
    DocumentListForm,
    RefreshListButton,
  },
  data() {
    return {
      fleetModule,
      sorting: {},
      itemsPerPage: this.$globalConstant.itemsPerPage,
      pageNo: 1,
      totalItems: 0,

      permissions: null,
      isChipsVisible: false,
      driverList: [],
      openDriverDetail: false,
      openDownloadDialog: false,
      selectedId: null,
      headerSelected: [
        {
          headerName: "Username",
          field: "username",
          sortable: false,
          pinned: "left",
          minWidth: 200,
        },
        {
          headerName: "Name",
          field: "full_name",
          sortable: false,
          pinned: "left",
          minWidth: 200,
        },
        {
          headerName: "Vehicle",
          field: "vehicle_assigned",
          sortable: false,
        },
        {
          headerName: "Branch",
          field: "branch",
          sortable: false,
        },
        {
          headerName: "Contact number",
          field: "contact_number",
          sortable: false,
        },
        {
          headerName: "Status",
          field: "verbose_status",
          sortable: false,
        },
        {
          headerName: "Shift Start",
          field: "shift_start",
          sortable: false,
        },
        {
          headerName: "Shift End",
          field: "shift_end",
          sortable: false,
        },
      ],

      isEditing: false,
      showDriverForm: false,
      selectedDriverID: null,

      isButtonDisabled: false,
      buttonTooltip: "Add Drivers",

      showBulkUploadDialog: false,

      showDriverStatusChangedDialog: false,
      selectedDriverStatus: false,

      documentUploadFormDialog: false,
      driverDetail: {},
    };
  },
  computed: {
    tableHeaders() {
      return [
        ...this.headerSelected,
        {
          headerName: "Actions",
          field: "actions",
          pinned: "right",
          minWidth: 200,
          maxWidth: 200,
          sortable: false,
          width: 200,
          cellRenderer: "DriverButton",
        },
      ];
    },
    context() {
      return { parentComponent: this };
    },
    profileObject() {
      let obj = localStorage.getItem("user_data");
      return obj ? JSON.parse(obj) : null;
    },
    ...mapState("userProfile", {
      driverFilters: (state) => state.driver_filters,
    }),
  },
  methods: {
    checkSubscriptionLimit() {
      this.$api.company
        .checkSubscriptionLimit(this.profileObject.company, {
          module: "driver",
        })
        .then(() => {
          this.isButtonDisabled = false;
          return true;
        })
        .catch((err) => {
          bus.$emit("showToastMessage", {
            message: err.data.non_field_errors[0],
            color: "error",
            timeout: 4000,
          });
          this.isButtonDisabled = true;
          this.buttonTooltip = err.data.non_field_errors[0];
          return false;
        });
    },
    getDocumentList(data) {
      this.driverDetail = data;
      this.documentUploadFormDialog = true;
    },
    resetFilters() {
      this.$store.commit("userProfile/resetFilters", {
        moduleKey: "driver_filters",
      });
      this.getDriverList({ limit: 10, offset: 0 });
    },
    getViewDetail(id) {
      this.$router.push({
        name: "driver-detail",
        params: { id: id },
      });

      // this.openDriverDetail = true;
      // this.selectedId = id;
    },
    async getDriverList(params = {}) {
      bus.$emit("showLoader", true);
      params = {
        ...params,
        ...this.driverFilters,
      };

      await this.$store.dispatch("userProfile/updateUserFilters", {
        filter_data: { ...this.driverFilters },
        filter_type: filterModules.DRIVER,
      });

      this.isChipsVisible = Object.keys(this.driverFilters).length > 0;

      this.$api.driver
        .getDriverList(params)
        .then((res) => {
          this.driverList = res.data;
          this.totalItems = res.count;
          bus.$emit("showLoader", false);
        })
        .catch((err) => {
          console.log(err);
          bus.$emit("showLoader", false);
        });
    },
    driverStatusChanged(id, currentStatus) {
      this.selectedDriverID = id;
      this.selectedDriverStatus = currentStatus;
      this.showDriverStatusChangedDialog = true;
    },
  },
  created() {
    this.permissions = this.$permissions.getPermission("fleet");
    this.checkSubscriptionLimit();
  },
};
</script>
